import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#707070" : "#858585")};
  background-color: ${(props) => (props.border ? "transparent" : "#20bfa9")};
  width: 100%;
  padding: 15px;
  outline: none;
  color: ${(props) => (props.border ? "#707070" : "#00000")};
  :hover {
    background-color: ${(props) => (props.border ? "transparent" : "#00b7ff")};
    border: 1px solid #000000;
    color: ${(props) => (props.border ? "#7620ff" : "#00000")};
  }
`;

